<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBItemList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-tabs>
              <b-tab :title="$t('views.exsbitems.form.basicParameters')">
                <EXSBItemForm
                  class="mt-2"
                  :page="1"
                  v-if="item"
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations"
                  :initial-values="retrieved" />
              </b-tab>
              <b-tab :title="$t('views.exsbitems.form.advancedParameters')">
                <EXSBItemForm
                  class="mt-2"
                  :page="2"
                  v-if="item"
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations"
                  :initial-values="retrieved" />
              </b-tab>
              <b-tab class="mt-2" :title="$t('views.exsbitems.show.itemPictures')">
                <ItemPictures :item="retrieved" v-model="pictureUploaded"></ItemPictures>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBItemForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import ItemPictures from '@/components/Dashboard/Views/BusinessBundle/exsbitem/components/ItemPictures'

export default {
  components: {
    ItemPictures,
    EXSBItemForm
  },

  data () {
    return {
      item: {},
      pictureUploaded: 0
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbitem/update/isLoading',
      error: 'exsbitem/update/error',
      deleteError: 'exsbitem/del/error',
      deleteLoading: 'exsbitem/del/isLoading',
      created: 'exsbitem/create/created',
      deleted: 'exsbitem/del/deleted',
      retrieved: 'exsbitem/update/retrieved',
      updated: 'exsbitem/update/updated',
      violations: 'exsbitem/update/violations'
    })
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemUpdate')
  },

  watch: {
    updated (val) {
      if (val && this.$route.name === 'EXSBItemUpdate') {
        this.$router.push({ name: 'EXSBItemList' })
      }
    },

    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBItemList' })
    },
    pictureUploaded: function () {
      if (this.pictureUploaded === 1) {
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.pictureUploaded = 0
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbitem/create/reset',
      deleteItem: 'exsbitem/del/del',
      delReset: 'exsbitem/del/reset',
      retrieve: 'exsbitem/update/retrieve',
      updateReset: 'exsbitem/update/reset',
      update: 'exsbitem/update/update',
      updateRetrieved: 'exsbitem/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbitem ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.minimumAvailability) this.retrieved.minimumAvailability = parseInt(this.retrieved.minimumAvailability)
      if (this.retrieved.warningAvailability) this.retrieved.warningAvailability = parseInt(this.retrieved.warningAvailability)
      if (this.retrieved.priceNetto) this.retrieved.priceNetto = this.retrieved.priceNetto.toString()
      if (this.retrieved.priceBrutto) this.retrieved.priceBrutto = this.retrieved.priceBrutto.toString()
      if (this.retrieved.height) this.retrieved.height = this.retrieved.height.toString()
      if (this.retrieved.width) this.retrieved.width = this.retrieved.width.toString()
      if (this.retrieved.weight) this.retrieved.weight = this.retrieved.weight.toString()
      if (typeof this.retrieved.rangeFrom === 'number') this.retrieved.rangeFrom = this.retrieved.rangeFrom.toString()
      if (typeof this.retrieved.rangeTo === 'number') this.retrieved.rangeTo = this.retrieved.rangeTo.toString()
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
